import React from "react";
import { Link } from "react-router-dom";

export default function Links() {
  return (
    <div>
      {/* Top Section */}
      <section className="links-top-section">
        <div className="top-container centered">
          <p className="eyebrow">Quick Access</p>
          <h1 className="main-heading">Important Links</h1>
          <p className="top-paragraph">
            Access key pages including portfolio, estimator, scripts, and case studies
            from one place.
          </p>
        </div>
      </section>

      {/* Links Section */}
      <section className="links-section">
        <div className="cards-container">

          {/* Link 1 */}
          <Link to="/yk" className="link-card">
            <div className="card-icon">👤</div>
            <h3>Yawar Khan Portfolio</h3>
            <p>View personal profile, experience, and projects.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 2 */}
          <Link to="/estimator" className="link-card">
            <div className="card-icon">🧮</div>
            <h3>Junk Removal Estimator</h3>
            <p>See how the estimator works and improves conversions.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 3 */}
          <Link to="/successstories" className="link-card">
            <div className="card-icon">📊</div>
            <h3>All Case Studies</h3>
            <p>Explore real results and success stories from clients.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 4 */}
          <Link to="/script" className="link-card">
            <div className="card-icon">📞</div>
            <h3>Sales Call Script</h3>
            <p>Step-by-step cold calling script for closing more deals.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 5 */}
          <Link to="/segment" className="link-card">
            <div className="card-icon">🔀</div>
            <h3>Segment Page</h3>
            <p>Go to the Segment page inside the app.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 6 */}
          <Link to="/hiring" className="link-card">
            <div className="card-icon">💼</div>
            <h3>Hiring Page</h3>
            <p>Apply for jobs and view current hiring opportunities.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 7 */}
          <Link to="/junkbid" className="link-card">
            <div className="card-icon">🚛</div>
            <h3>JunkBid Form</h3>
            <p>Submit junk removal bids and manage job requests.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 8 */}
          <Link to="/software-selection" className="link-card">
            <div className="card-icon">💻</div>
            <h3>Software Selection Form</h3>
            <p>Submit software project inquiries and requirements.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 9 */}
          <Link to="/first30days" className="link-card">
            <div className="card-icon">📅</div>
            <h3>First 30 Days</h3>
            <p>View the first 30 days onboarding plan and action steps.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 10 */}
          <Link to="/softwarecasestudy" className="link-card">
            <div className="card-icon">🖥️</div>
            <h3>Software Case Studies</h3>
            <p>View real client acquisition results across SaaS and software companies.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 11 — How It Works */}
          <Link to="/cca1" className="link-card">
            <div className="card-icon">🗺️</div>
            <h3>cca1</h3>
            <p>The architecture of predictable growth — our 4-phase journey explained.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 12 — Commercial Clients */}
          <Link to="/cca2" className="link-card">
            <div className="card-icon">🏢</div>
            <h3>cca2</h3>
            <p>Private invitation — pricing plans and territory claim for commercial growth.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 13 — AI Voice System */}
          <Link to="/deskmanager" className="link-card">
            <div className="card-icon">🤖</div>
            <h3>deskmanager</h3>
            <p>Never miss a call again — AI assistant that answers, talks, and books jobs.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 14 — Field Management System */}
          <Link to="/JB" className="link-card">
            <div className="card-icon">📱</div>
            <h3>JB</h3>
            <p>Run scheduling, quoting, and payments from your phone in one click.</p>
            <span className="card-arrow">→</span>
          </Link>

          {/* Link 15 — Smart Sales System (CRM) */}
          <Link to="/GL" className="link-card">
            <div className="card-icon">📈</div>
            <h3>GL</h3>
            <p>Auto follow-up, bulk outreach, social posting, and 5-star review automation.</p>
            <span className="card-arrow">→</span>
          </Link>

        </div>
      </section>

      {/* Styles */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

        .links-top-section {
          background: #000;
          color: #fff;
          padding: 100px 20px 90px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .top-container {
          max-width: 860px;
          margin: 0 auto;
        }

        .centered {
          text-align: center;
        }

        .eyebrow {
          display: inline-block;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #a855f7;
          background: rgba(168, 85, 247, 0.12);
          border: 1px solid rgba(168, 85, 247, 0.25);
          padding: 6px 16px;
          border-radius: 100px;
          margin-bottom: 24px;
        }

        .main-heading {
          font-size: 58px;
          font-weight: 900;
          letter-spacing: -0.03em;
          line-height: 1.1;
          margin: 0 0 20px;
          background: linear-gradient(135deg, #fff 0%, #d8b4fe 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .top-paragraph {
          font-size: 18px;
          color: rgba(255,255,255,0.6);
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.7;
        }

        .links-section {
          background: #f9f9fb;
          padding: 90px 20px;
          font-family: 'Inter', sans-serif;
        }

        .cards-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          max-width: 1080px;
          margin: 0 auto;
        }

        .link-card {
          background: #fff;
          padding: 32px 28px;
          border-radius: 18px;
          text-decoration: none;
          color: #000;
          border: 1px solid rgba(0,0,0,0.07);
          box-shadow: 0 2px 12px rgba(0,0,0,0.06);
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .link-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 16px 40px rgba(123, 25, 188, 0.15);
          border-color: rgba(168, 85, 247, 0.3);
        }

        .card-icon {
          font-size: 28px;
        }

        .link-card h3 {
          font-size: 18px;
          font-weight: 700;
          margin: 0;
        }

        .link-card p {
          font-size: 14px;
          color: #666;
          margin: 0;
        }

        .card-arrow {
          font-size: 18px;
          color: #a855f7;
          margin-top: 8px;
        }

        @media (max-width: 900px) {
          .cards-container {
            grid-template-columns: repeat(2, 1fr);
          }
          .main-heading {
            font-size: 42px;
          }
        }

        @media (max-width: 560px) {
          .cards-container {
            grid-template-columns: 1fr;
          }
          .main-heading {
            font-size: 34px;
          }
        }
      `}</style>
    </div>
  );
}
